import { RootState } from "../Store";
// Selector to get the user
export const selectUser = (state: RootState) => state.auth.user;

// Selector to get the auth token
export const selectToken = (state: RootState) => state.auth.token;

// Selector to check if user is authenticated
export const selectIsAuthenticated = (state: RootState) => !!state.auth.token;
